import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import logo from '../assets/Images/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-[rgba(255,255,255,0.98)] backdrop-blur-[10px] shadow-[0_2px_10px_rgba(0,0,0,0.05)] z-[1000] transition-all duration-300 py-3 md:py-4 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex justify-between items-center">
          <Link
            to="/"
            className="flex items-center gap-2 sm:gap-3 max-w-[85%]"
          >
            <img
              src={logo}
              alt="Hospet Hydraulics Solutions Logo"
              className="h-10 sm:h-14 md:h-16 w-auto object-contain flex-shrink-0"
            />
            <span className="flex flex-col">
              <span className="text-[13px] sm:text-[1rem] md:text-[1.2rem] font-bold text-[var(--primary-color)] hover:text-[var(--secondary-color)] transition-colors duration-300 leading-tight">
                Hospet Hydraulics Solutions
              </span>
              <span className="text-[10px] sm:text-xs text-yellow-600 mt-0.5">Fluid Expertise, Trusted Solutions</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:block">
            <ul className="flex gap-8 list-none m-0 p-0">
              {['Home', 'About', 'Portfolio', 'Services', 'Contact'].map((item) => (
                <li key={item} className="relative group">
                  <Link
                    to={`/${item.toLowerCase() === 'home' ? '' : item.toLowerCase()}`}
                    className="text-[var(--primary-color)] no-underline font-medium text-[0.95rem] hover:text-[var(--secondary-color)] transition-colors duration-300 relative"
                  >
                    {item}
                    <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[var(--secondary-color)] transition-all duration-300 group-hover:w-full"></span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Mobile menu button */}
          <button
            className="md:hidden text-[var(--primary-color)] focus:outline-none"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4">
            <ul className="flex flex-col gap-4 list-none m-0 p-0">
              {['Home', 'About', 'Portfolio', 'Services', 'Contact'].map((item) => (
                <li key={item} className="relative">
                  <Link
                    to={`/${item.toLowerCase() === 'home' ? '' : item.toLowerCase()}`}
                    className="block py-2 px-2 text-[var(--primary-color)] no-underline hover:text-[var(--secondary-color)] transition-colors duration-300"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item}
                    <span className="absolute bottom-1 left-2 w-0 h-0.5 bg-[var(--secondary-color)] transition-all duration-300 group-hover:w-[calc(100%-1rem)]"></span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;